<template>
  <router-view />
</template>

<script>
export default {
  name: "SubPage"
}
</script>
